import Link from "next/link";
import { useRouter } from "next/router";

export default function Navigation({
  data,
  parent,
  itemClass,
  order = true,
  activeStyle = "text-black",
}) {
  const router = useRouter();
  const { pathname, query } = router;

  if (!data) return null;

  const getActiveStyle = (route) => {
    const defaultStyle = "text-gamma";

    if (`/${query.slug}` === route) return activeStyle;
    if (pathname.startsWith(route)) return activeStyle;
    return defaultStyle;
  };

  const getPathname = (slug) => {
    return `${parent === "home" ? "/" : `/${parent}/`}${slug}`;
  };

  let navData = order ? data.sort((a, b) => a.order - b.order) : data;

  // home should not be listed in nav so we filter that out
  navData = navData.filter((nav) => nav.slug !== "home");

  return navData.map(({ id, slug, title }) => {
    return (
      <Link key={id} href={{ pathname: getPathname(slug) }}>
        <a
          className={`uppercase hover:no-underline ${itemClass} ${getActiveStyle(
            `/${slug}`,
          )}`}
        >
          {title}
        </a>
      </Link>
    );
  });
}
